<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Into the Thinking Kingdoms</h1>
<p class="author"><a id="page_iii"></a>Alan Dean Foster</p>
<div class="img_containert"><img alt="image" src="images/logo.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Title.vue?5e0f631f